import * as React from 'react';
import { Button, ButtonToolbar } from 'react-bootstrap';
import IPlanFirm from './IPlanFirm';
import { Translate } from '../../shared/LanguageService';
import DeleteButton from '../../components/common/DeleteButton';

interface IPlanFirmListRowProps {
    planFirm: IPlanFirm;
    beginEdit: (id: number) => void;
    delete: (id: number) => void;
}

const PlanFirmListRow = (props: IPlanFirmListRowProps) => {
    return (
        <tr>
            <td>{props.planFirm.name}</td>
            <td className="tools">
                <ButtonToolbar className="pull-right btn-group-sm">
                    <DeleteButton
                        onDelete={() => props.delete(props.planFirm.id)}
                        text={Translate('plan-firms/list/row/delete/remove-this-plan-firm')}
                    >
                        <i className="material-icons">delete</i>{' '}
                        {Translate('plan-firms/list/row/button-label/delete')}
                    </DeleteButton>
                    <Button
                        onClick={props.beginEdit.bind(null, props.planFirm.id)}
                        bsStyle="primary"
                    >
                        <i className="material-icons">edit</i>{' '}
                        {Translate('plan-firms/list/row/button-label/edit')}
                    </Button>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default PlanFirmListRow;
